import { render, staticRenderFns } from "./auditGoldWithdrawal.vue?vue&type=template&id=502aeeb5"
import script from "./auditGoldWithdrawal.vue?vue&type=script&lang=js"
export * from "./auditGoldWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports